import { Tag, X } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/shared/components/ui/tooltip';

import TagSelector from './ui/TagSelector';
import { Page } from '@/features/pages/types/page.types';
import { useTagActions } from '@/features/tags/hooks/useTagActions';
import { useTagsQuery } from '@/features/tags/hooks/useTagsQuery';

const TagInput = ({ page, editable }: { page: Page; editable: boolean }) => {
  const { data: tags = [] } = useTagsQuery();
  const { assignTag, unassignTag, deleteTag, updateTag, toggleFilter } = useTagActions();
  const pageTags = page.tags || [];

  if (!editable && pageTags.length === 0) return null;

  const trigger = (
    <div className="mb-4 mx-2 md:mx-10 flex items-center">
      <div className="flex flex-wrap gap-2 items-center px-2">
        {pageTags.map(tag => (
          <div
            onClick={e => {
              e.stopPropagation();
              toggleFilter(tag);
            }}
            key={tag}
            className="flex items-center gap-2 px-3 py-1 bg-secondary rounded-full text-sm border-2 border-border cursor-pointer"
          >
            <span>{tag}</span>
            {editable ? (
              <button
                onClick={e => {
                  e.stopPropagation();
                  void unassignTag(page.id, tag);
                }}
                className="text-muted-foreground hover:text-foreground cursor-pointer"
              >
                <X className="h-3 w-3" />
              </button>
            ) : null}
          </div>
        ))}
      </div>
      {editable ? (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <div className="flex items-center opacity-60 hover:opacity-100 transition-opacity cursor-pointer">
                <Tag className="text-foreground h-4 w-4" />
              </div>
            </TooltipTrigger>
            <TooltipContent>
              <p>Tag Page</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ) : null}
    </div>
  );

  return (
    <TagSelector
      trigger={trigger}
      tags={tags}
      selectedTags={pageTags}
      onSelect={tag =>
        void (pageTags.includes(tag) ? unassignTag(page.id, tag) : assignTag(page.id, tag))
      }
      onDelete={deleteTag}
      onEdit={updateTag}
      allowNewTags
      emptyMessage="No tags yet"
    />
  );
};

export default TagInput;
